var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5478 28.1408C29.3788 28.8363 28.8363 29.3788 28.1408 29.5478C20.1717 31.4841 11.8283 31.4841 3.85921 29.5478C3.16372 29.3788 2.62121 28.8363 2.45222 28.1408C0.515928 20.1717 0.515927 11.8283 2.45222 3.85921C2.62121 3.16372 3.16372 2.6212 3.85921 2.45222C11.8283 0.515927 20.1717 0.515928 28.1408 2.45222C28.8363 2.62121 29.3788 3.16372 29.5478 3.85921C31.4841 11.8283 31.4841 20.1717 29.5478 28.1408Z",
    fill: "#80AF26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5478 28.1408C29.3788 28.8363 28.8363 29.3788 28.1408 29.5478C20.1717 31.4841 11.8283 31.4841 3.85921 29.5478C3.16372 29.3788 2.62121 28.8363 2.45222 28.1408C0.515928 20.1717 0.515927 11.8283 2.45222 3.85921C2.62121 3.16372 3.16372 2.6212 3.85921 2.45222C11.8283 0.515927 20.1717 0.515928 28.1408 2.45222C28.8363 2.62121 29.3788 3.16372 29.5478 3.85921C31.4841 11.8283 31.4841 20.1717 29.5478 28.1408Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7,
    y1: 31,
    x2: 7,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.35080726656960c5bb93761332e4dd39.svg";
export { ForwardRef as ReactComponent };